module.exports = __webpack_public_path__ + "static/media/airplane-arrival.23a89d6e.svg";